const checkTtl = () => {
    /**
     * iOS Safariでも正確に動作する、テキストの自動改行検出関数だよ！
     * @param {HTMLElement} element - 確認したい要素
     * @returns {Array<{text: string, lineNumber: number}>} 各行のテキストと行番号
     *
     * @example
     * // HTML: <p style="width: 100px">これは長いテキストで自動的に改行されます</p>
     * const para = document.querySelector('p');
     * const lines = detectAutoLineBreaks(para);
     * console.log(lines);
     */
    const detectAutoLineBreaks = (element) => {
        const range = document.createRange();
        const lines = [];
        let currentLine = [];
        let prevBottom = null;
        let lineNumber = 1;
        const THRESHOLD = 0; // iOS Safariのための余裕を持たせる

        // 要素の初期位置を取得
        const elementRect = element.getBoundingClientRect();

        element.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                for (let i = 0; i < text.length; i++) {
                    const char = text[i];

                    range.setStart(node, i);
                    range.setEnd(node, i + 1);
                    const rects = range.getClientRects();

                    if (rects.length > 0) {
                        const rect = rects[0];
                        const normalizedBottom = rect.bottom - elementRect.top;

                        // 初期化
                        if (prevBottom === null) {
                            prevBottom = normalizedBottom;
                        }

                        // より正確な行の判定
                        if (
                            Math.abs(normalizedBottom - prevBottom) > THRESHOLD
                        ) {
                            if (currentLine.length > 0) {
                                lines.push({
                                    text: currentLine.join(""),
                                    lineNumber: lineNumber,
                                });
                                currentLine = [];
                                lineNumber++;
                                prevBottom = normalizedBottom;
                            }
                        }

                        currentLine.push(char);
                    }
                }
            }
        });

        // 最後の行を追加
        if (currentLine.length > 0) {
            lines.push({
                text: currentLine.join(""),
                lineNumber: lineNumber,
            });
        }

        return lines;
    };
    const ttls = document.querySelectorAll(
        `.cnt__rowsRowUpperTtl h2.mq4sp.auto`
    );

    ttls.forEach((ttl) => {
        const txtdata = detectAutoLineBreaks(ttl);
        let ctxt = "";
        txtdata.forEach((td) => {
            ctxt += `<span class="linerow row-${td.lineNumber}">${td.text}</span>`;
        });

        ttl.innerHTML = ctxt;
        ttl.classList.add("is-spaned");
    });
};

if (document.body.classList.contains("single-recruit")) {
    let hasExecuted = false;
    let resizeTimer;

    if (window.innerWidth <= 1024) {
        window.addEventListener("load", () => {
            checkTtl();
            hasExecuted = true;
        });
    }

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (!hasExecuted && window.innerWidth <= 1024) {
                checkTtl();
                hasExecuted = true;
            }
        }, 250); // 250ミリ秒のデバウンス
    });
}
